import TypesenseInstantSearchAdapter, {
  BaseSearchParameters,
} from "typesense-instantsearch-adapter"

export function createTypesenseSearchClient(
  clientKey: string,
  queryableFields: string[],
  resultsPerPage: number,
  sortBy?: string
) {
  const protocol = window.location.protocol.replace(/:$/, "")

  const additionalSearchParameters: BaseSearchParameters<Record<string, any>> =
    {
      query_by: queryableFields.join(","),
      per_page: resultsPerPage,
    }

  if (sortBy) {
    additionalSearchParameters.sort_by = sortBy
  }

  const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: clientKey,
      nodes: [
        {
          path: "/api/search",
          host: window.location.hostname,
          port: parseInt(protocol === "https" ? "443" : window.location.port),
          protocol: protocol,
        },
      ],
    },
    additionalSearchParameters: additionalSearchParameters,
  })

  return typesenseInstantsearchAdapter.searchClient
}
